import { Pipe, PipeTransform } from '@angular/core';

/**
 * A pipe for human-readable file size representation.
 */
@Pipe({
  name: 'filesize'
})
export class FileSizePipe implements PipeTransform {
  /**
   * Transform a file size from bytes (as number) to formatted string.
   * @param value File size in bytes to transform
   * @param precision The precision of transformed filesize
   * @param isBinary Calc in binary system otherwise - decimal
   * @returns A string which represents a human-readable version of file size expressed in bytes.
   */
  transform(value: any, precision: number = 1, isBinary = false): any {
    const baseSize = isBinary ? 1024 : 1000;
    const bytes: number = value ? value : 0;
    const exp: number = (Math.log(bytes) / Math.log(baseSize)) | 0;
    let result: string = (bytes / Math.pow(baseSize, exp)).toFixed(precision);

    result = result.replace(/\.(0)+$/, '');

    return (result + ' ' + (exp == 0 ? 'bytes' : 'KMGTPEZY'[exp - 1] + 'B'))
      .replace('.', ',');
  }
}
